var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPkgSelectGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.244141,
    y: 0.152344,
    width: 72,
    height: 72,
    rx: 16,
    fill: "#ECEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2441 17.1523C31.205 17.1523 26.3723 19.1541 22.8091 22.7173C19.2459 26.2805 17.2441 31.1132 17.2441 36.1523C17.2441 41.1915 19.2459 46.0242 22.8091 49.5874C26.3723 53.1506 31.205 55.1523 36.2441 55.1523L36.2441 36.1523V17.1523Z",
    fill: "#4A3AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2441 55.1523C41.2833 55.1523 46.116 53.1506 49.6792 49.5874C53.2424 46.0242 55.2441 41.1915 55.2441 36.1523C55.2441 31.1132 53.2424 26.2805 49.6792 22.7173C46.116 19.1541 41.2833 17.1523 36.2441 17.1523L36.2441 36.1523L36.2441 55.1523Z",
    fill: "#B8B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkgSelectGradient);
export default __webpack_public_path__ + "static/media/pkg-select-gradient.5ebedaef50f7b5082a311e0103c754cc.svg";
export { ForwardRef as ReactComponent };